<template>
  <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8">
    <li class="nav-item">
      <a class="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#principais">Dados do Usuário</a>
    </li>
    <li class="nav-item" v-if="model.tipo?.indexOf('Avaliador') > -1">
      <a class="nav-link text-active-primary pb-4" data-kt-countup-tabs="true" data-bs-toggle="tab" href="#interesses">Interesses</a>
    </li>
  </ul>
  <div class="tab-content">
    <div id="principais" role="tabpanel" class="tab-pane fade active show">
      <div class="row mb-3">
        <div :class="{'col-12': profile, 'col-8': !profile}">
          <form-group label="Nome completo" :is-invalid="form.errors.name">
            <input
                v-model="model.name"
                class="form-control"
                type="text"
                placeholder="Nome completo"
                @blur="model.clearErrors('name')"
                :class="{'is-invalid' : model.errors.name}"
                maxlength="100"
            />
          </form-group>
        </div>

        <div class="col-4" v-if="!profile">
          <form-group label="Permissão" :is-invalid="form.errors.tipos">
            <select class="form-select" data-control="select2" v-select2
                    data-placeholder="Selecione uma opção"
                    @change="model.clearErrors('tipos')"
                    multiple v-model="model.tipos">
              <option value="1">Administrador</option>
              <option value="2">Orientador</option>
              <option value="3">Avaliador</option>
            </select>
          </form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <form-group label="E-mail" :is-invalid="model.errors.email">
            <input
                v-model="model.email"
                class="form-control mb-2"
                type="email"
                placeholder="email@gmail.com"
                @blur="model.clearErrors('email')"
                :class="{'is-invalid' : model.errors.email}"
                maxlength="50"
            />
          </form-group>
        </div>

        <div class="col-6">
          <form-group label="Senha" :is-invalid="model.errors.password">
            <input
                v-model="model.password"
                class="form-control mb-2"
                type="password"
                placeholder="Sua senha"
                @blur="model.clearErrors('password')"
                :class="{'is-invalid' : model.errors.password}"
                maxlength="50"
            />
            <div class="text-muted fs-7" v-if="editing">
              Preencha para alterar sua senha atual.
            </div>
          </form-group>
        </div>
      </div>
    </div>
    <div id="interesses" role="tabpanel" class="tab-pane fade">
      <div class="row">
        <div class="col-3 mb-3" v-for="(formacao, index) in form.interesses">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input"
                   type="checkbox"
                   :name="formacao.nome"
                   :value="formacao.id"
                   :id="formacao.nome"
                   v-model="form.avaliador_interesses"/>
            <label class="form-check-label" :for="formacao.nome">
              {{ formacao.nome }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubmitButton from "@forms/SubmitButton";
import FormGroup from "@forms/FormGroup";
import axios from "axios";
import {error} from "@settings/toastr";

export default {
  props: {
    form: {
      type: Object
    },
    editing: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormGroup,
    SubmitButton,
  },

  data: _ => ({
    model: {},
  }),

  created() {
    this.init();
  },

  methods: {
    init() {
      this.model = this.form;
      if (this.editing && !this.profile) {
        const tipos = [
          ...(this.model.tipo.indexOf('Administrador') > -1 ? [1] : []),
          ...(this.model.tipo.indexOf('Orientador') > -1 ? [2] : []),
          ...(this.model.tipo.indexOf('Avaliador') > -1 ? [3] : []),
        ];

        this.model.tipos.push(...tipos)
      }
    },
  },
}
</script>
